const MOUTHS = {
  neutral: "M50 64 Q60 69 70 64",
  happy: "M45 61 Q60 75 75 61",
  think: "M52 66 L68 63",
  worried: "M48 68 Q60 60 72 68",
  sleepy: "M55 65 Q60 67 65 65",
};

const CHEST = { happy: "#A3E635", think: "#F472B6", worried: "#FBBF24", sleepy: "#475569" };

const LABELS = {
  neutral: "Bit, der Lernroboter",
  happy: "Bit freut sich",
  think: "Bit denkt nach",
  worried: "Bit ist besorgt",
  sleepy: "Bit döst",
};

const ACCENT = "#22D3EE";
const stroke = (w) => ({ strokeWidth: w, strokeLinecap: "round" });

/** Bit as SVG. lookX/lookY in [-1, 1] move the pupils; "think" looks up and away. */
export default function BitAvatar({ mood = "neutral", lookX = 0, lookY = 0, talking = false, size = 96, className = "" }) {
  const m = MOUTHS[mood] ? mood : "neutral";
  const lx = m === "think" ? 0.6 : Math.max(-1, Math.min(1, lookX));
  const ly = m === "think" ? -1 : Math.max(-1, Math.min(1, lookY));
  const eyesOpen = m === "neutral" || m === "think" || m === "worried";

  return (
    <svg width={size} height={size} viewBox="0 0 120 120" role="img" aria-label={LABELS[m]} className={`block shrink-0 ${className}`}>
      <line x1="60" y1="22" x2="60" y2="10" stroke="#475569" style={stroke(3)} />
      <circle cx="60" cy="8" r="5" fill={m === "sleepy" ? "#475569" : "#F472B6"} className={m === "think" ? "bit-blink" : ""} />
      <rect x="8" y="42" width="12" height="22" rx="5" fill="#1E293B" stroke="#334155" style={stroke(2)} />
      <rect x="100" y="42" width="12" height="22" rx="5" fill="#1E293B" stroke="#334155" style={stroke(2)} />
      <rect x="18" y="22" width="84" height="62" rx="20" fill="#1E293B" stroke={ACCENT} style={stroke(2.5)} />
      <rect x="28" y="32" width="64" height="42" rx="13" fill="#070B14" />
      {eyesOpen && (
        <>
          <circle cx="46" cy="50" r="9" fill={ACCENT} opacity="0.18" />
          <circle cx="74" cy="50" r="9" fill={ACCENT} opacity="0.18" />
          <circle cx={46 + lx * 3.5} cy={50 + ly * 3} r="5" fill={ACCENT} />
          <circle cx={74 + lx * 3.5} cy={50 + ly * 3} r="5" fill={ACCENT} />
        </>
      )}
      {m === "happy" && (
        <>
          <path d="M38 53 Q46 42 54 53" fill="none" stroke={ACCENT} style={stroke(3.5)} />
          <path d="M66 53 Q74 42 82 53" fill="none" stroke={ACCENT} style={stroke(3.5)} />
        </>
      )}
      {m === "sleepy" && (
        <>
          <path d="M38 51 Q46 55 54 51" fill="none" stroke="#64748B" style={stroke(3)} />
          <path d="M66 51 Q74 55 82 51" fill="none" stroke="#64748B" style={stroke(3)} />
        </>
      )}
      {m === "worried" && (
        <>
          <path d="M37 39 L52 42" fill="none" stroke="#FBBF24" style={stroke(2.5)} />
          <path d="M83 39 L68 42" fill="none" stroke="#FBBF24" style={stroke(2.5)} />
        </>
      )}
      <path
        d={MOUTHS[m]}
        fill="none"
        stroke={m === "sleepy" ? "#64748B" : ACCENT}
        className={talking ? "bit-talk" : ""}
        style={stroke(3)}
      />
      <rect x="36" y="88" width="48" height="24" rx="10" fill="#1E293B" stroke="#334155" style={stroke(2)} />
      <circle cx="60" cy="100" r="4.5" fill={CHEST[m] || ACCENT} />
      <line x1="44" y1="100" x2="52" y2="100" stroke="#334155" style={stroke(2)} />
      <line x1="68" y1="100" x2="76" y2="100" stroke="#334155" style={stroke(2)} />
    </svg>
  );
}
